module.exports = __webpack_public_path__ + "static/media/EndCall.f806c749.svg";